import { Directive, ElementRef, HostListener } from '@angular/core';
import { NbTooltipDirective } from '@nebular/theme';

@Directive({
  selector: '[TartEllipsisTooltip]',
})
export class TartEllipsisTooltipDirective {

  constructor(
    private el: ElementRef,
    private tooltip: NbTooltipDirective,
  ) {
    this.el.nativeElement.style.whiteSpace = 'nowrap';
    this.el.nativeElement.style.overflow = 'hidden';
    this.el.nativeElement.style.textOverflow = 'ellipsis';
    this.tooltip.disabled = true;
    this.tooltip.rebuild();
   }


  @HostListener('mouseleave')
  onMouseLeave() {
    this.tooltip.disabled = true;
    this.tooltip.rebuild();
  }

  @HostListener('mouseenter')
  onMouseEnter() {
    this.detectEllipsis();
  }

  detectEllipsis() {
    const isEllipsis = this.el.nativeElement.scrollWidth > this.el.nativeElement.clientWidth;

    if (isEllipsis) {
      this.tooltip.content = this.el.nativeElement.textContent.trim();
      this.tooltip.disabled = false;
      this.tooltip.rebuild();
      this.tooltip.show();
    } else {
      this.tooltip.disabled = true;
      this.tooltip.rebuild();
    }
  }

}
